export * from './payment-names';
export * from './paypal';
export * from './stripe';
export * from './take-payments';

